import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import CaretDownSvg from '../../../assets/icons/app/caret-down.svg?raw';

export const CaretDownIcon = (props) => <CustomSVG svg={CaretDownSvg} preserveColors appIconSmall {...props} />;
